import { Icon as AvatarIcon } from '@/components/Custom/Avatar';
import TagGroupSelect from '@/components/Custom/TagGroupSelect';
import Box from '@/components/Unistyles/Box';
import Text from '@/components/Unistyles/Text';
import TextInput from '@/components/Unistyles/TextInput';
import { MAXIMUM_TEAM_TITLE_LENGTH } from '@/utils/constants';
import getOffsetColor from '@/utils/getOffsetColor';
import AvatarColorPicker from './AvatarColorPicker';

type TeamProfileFieldsProps = {
  autoFocus?: boolean;
  color: string;
  errorMessage?: string | null;
  localAvatarUrl?: string | null;
  onChangeColor(color: string): void;
  onChangeLocalAvatarUrl(localAvatarUrl: string): void;
  onChangeTagGroupId(tagGroupId: string | null): void;
  onChangeTitle(title: string): void;
  showAvatarPreview?: boolean;
  showTagGroup?: boolean;
  showTitle?: boolean;
  tagGroupId?: string | null;
  title: string;
};

export default function TeamProfileFields({
  autoFocus = false,
  color,
  errorMessage,
  localAvatarUrl,
  onChangeColor,
  onChangeLocalAvatarUrl,
  onChangeTagGroupId,
  onChangeTitle,
  showAvatarPreview = true,
  showTagGroup = true,
  showTitle = true,
  tagGroupId,
  title,
}: TeamProfileFieldsProps) {
  return (
    <>
      {showAvatarPreview ? (
        <AvatarColorPicker
          avatarSize="xl"
          color={color}
          localAvatarUrl={localAvatarUrl}
          name={title.trim() || 'Team name'}
          nameSize="2xl"
          onChangeColor={onChangeColor}
          onChangeLocalAvatarUrl={onChangeLocalAvatarUrl}
        >
          <AvatarIcon
            name="camera-outline"
            size="4xl"
            color={getOffsetColor(color, false)}
          />
        </AvatarColorPicker>
      ) : null}

      <Box space="md">
        {showTitle ? (
          <TextInput
            autoCapitalize="words"
            autoFocus={autoFocus}
            enterKeyHint="done"
            maxLength={MAXIMUM_TEAM_TITLE_LENGTH}
            placeholder="Team name"
            value={title}
            onChangeText={onChangeTitle}
          />
        ) : null}
        {showTagGroup ? (
          <TagGroupSelect
            selected={tagGroupId ? [tagGroupId] : []}
            onPress={(pressedTagGroupId) => {
              onChangeTagGroupId(
                tagGroupId === pressedTagGroupId ? null : pressedTagGroupId,
              );
            }}
          />
        ) : null}
        {errorMessage ? (
          <Text variant="error" center selectable>
            {errorMessage}
          </Text>
        ) : null}
      </Box>
    </>
  );
}
